import config from '@src/config'

import type Transport from '.'
import type {
  MarketplaceCollectionConfigureRequest,
  MarketplaceCollectionConfigureResponse,
  MarketplaceCollectionInstallResponse,
  MarketplaceCollectionUninstallResponse,
  MarketplaceCustomActionCollectionList,
} from './marketplace-client/marketplaceSchema'
import { HttpTransaction } from './transaction'

export interface MarketplacePackage {
  id: string
  title: string
}

export interface ImportPackageResponse {
  workflowDefinitions: string
}

export default class MarketplaceClient {
  constructor(private transport: Transport) {}

  packages = {
    list: (): Promise<MarketplacePackage[]> =>
      this.transport.queue(
        new HttpTransaction({ url: `${config.MARKETPLACE_SERVICE_URL}packages` }),
      ),

    import: (packageId: string, entityId: string): Promise<ImportPackageResponse> =>
      this.transport.queue(
        new HttpTransaction({
          method: 'post',
          url: `${config.MARKETPLACE_SERVICE_URL}packages/${packageId}/import`,
          body: { entityId },
        }),
      ),
  }

  customActionCollections = {
    list: (signal?: AbortSignal): Promise<MarketplaceCustomActionCollectionList> =>
      this.transport.queue(
        new HttpTransaction({
          url: `${config.MARKETPLACE_SERVICE_URL}custom-action-collections`,
          method: 'GET',
          signal,
        }),
      ),

    install: (
      marketplaceItemId: string,
      signal?: AbortSignal,
    ): Promise<MarketplaceCollectionInstallResponse> =>
      this.transport.queue(
        new HttpTransaction({
          method: 'post',
          url: `${config.MARKETPLACE_SERVICE_URL}custom-action-collections/${marketplaceItemId}/install`,
          body: {},
          signal,
        }),
      ),

    configure: (
      marketplaceItemId: string,
      body: MarketplaceCollectionConfigureRequest,
      signal?: AbortSignal,
    ): Promise<MarketplaceCollectionConfigureResponse> =>
      this.transport.queue(
        new HttpTransaction({
          method: 'put',
          url: `${config.MARKETPLACE_SERVICE_URL}custom-action-collections/${marketplaceItemId}/configure`,
          body,
          signal,
        }),
      ),

    uninstall: (
      marketplaceItemId: string,
      signal?: AbortSignal,
    ): Promise<MarketplaceCollectionUninstallResponse> =>
      this.transport.queue(
        new HttpTransaction({
          method: 'post',
          url: `${config.MARKETPLACE_SERVICE_URL}custom-action-collections/${marketplaceItemId}/uninstall`,
          body: {},
          signal,
        }),
      ),
  }
}
